import React, { useState, useCallback } from 'react'

import Input from '../input'
import { EditIcon } from '../icons'
import TranslatesModal from '../translatesModal'

const inputStyle = { width: 'calc(100% - 50px)' }

const TranslatedInput = ({
  onTranslationChange,
  translates = {},
  locales,
  defaultLocale,
  translatedField,
  optional,
  disabled,
  ...props
}) => {

  const [modalOpened, setModalOpened] = useState(false)

  const handleOpen = useCallback(() => {
    if (!modalOpened) {
      setModalOpened(true)
    }
  }, [modalOpened])

  const handleClose = useCallback(() => {
    if (modalOpened) {
      setModalOpened(false)
    }
  }, [modalOpened])

  const handleConfirm = useCallback(values => {
    setModalOpened(false)
    onTranslationChange(translatedField, values)
  }, [onTranslationChange, translatedField])

  const handleClick = useCallback(e => {
    if (!e.target.value) {
      handleOpen()
    }
  }, [handleOpen])

  return (
    <React.Fragment>
      <Input
        {...props}
        onClick={handleClick}
        onAction={handleOpen}
        actionIcon={<EditIcon />}
        inputStyle={inputStyle}
        readOnly
        disabled={disabled}
      />
      {
        modalOpened && (
          <TranslatesModal
            translates={translates}
            locales={locales}
            defaultLocale={defaultLocale}
            onClose={handleClose}
            onChange={handleConfirm}
            optional={optional}
            disabled={disabled}
          />
        )
      }
    </React.Fragment>
  )
}

export default TranslatedInput
